<template>
  <v-card flat>
    <v-card-text>
      <v-container fluid>
        <v-layout>
          <v-flex>
            <v-select
              label="Included Projects"
              autocomplete
              :loading="loading"
              multiple
              chips
              :items="items"
              item-text="name"
              item-value="id"
              :search-input.sync="search"
              v-model="select"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>


<script>
  import {
    Api
  } from '../../../services';
  import queryString from 'query-string';
  import Loader from '../Components/Loader.vue';
  import _ from 'lodash';

  export default {
    props: ['clientId'],
    data() {
      return {
        loading: false,
        items: [],
        search: null,
        select: false,
        states: []
      }
    },
    watch: {
      clientId(val){
        if (val) {
          this.getProjects(val);
        } else {
          this.select = false;
          this.items = [];
        }
      },

      search(val) {
        val && this.querySelections(val)
      },
      select(selected) {
        if (_.isArray(selected) && !_.isEmpty(selected))
          return this.$emit('selected', selected);

        return this.$emit('selected');
      }
    },
    methods: {
      querySelections(name) { },
      getProjects(clientId = null){
        this.loading = true;
        Api
          .Projects()
          .all()
          .then((res) => {
            this.items = [];
            console.log('PROJECTS: ', res.data);

            let projectsForClient = _.filter(res.data, project => project.client.id === clientId);
            return this.items = _.sortBy(projectsForClient, project => project.name)
          })
          .then(() => this.loading = false)
          .catch(err => {
            console.log('ERRRR', err);
            this.loading = false
          })
      }
    },

    mounted() {
      console.log("CLIENT_ID: ", this.client_id);
    }
  }
</script>


<style>
  /* .primary--text{
          color: #757575!important;
      } */
</style>



// WEBPACK FOOTER //
// src/components/Admin/Reports/ProjectSelector.vue